export default "__VITE_ASSET__uLTO$4va__"